module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



// WEBPACK FOOTER //
// ./~/es-abstract/helpers/isNaN.js